import { useQuery } from '@tanstack/react-query';
import { workoutApi } from '@/api/workouts';
import { ApiError } from '@/api/client';
import type { WorkoutStats } from '@/types/Workout';

export const workoutStatsKey = ['workout-stats'] as const;

interface UseWorkoutStatsResult {
  stats: WorkoutStats[];
  loading: boolean;
  error: string | null;
}

export function useWorkoutStats(enabled: boolean): UseWorkoutStatsResult {
  const query = useQuery<WorkoutStats[], Error>({
    queryKey: workoutStatsKey,
    queryFn: () => workoutApi.stats().then((s) => s ?? []),
    enabled,
  });

  const errIsAuth =
    query.error instanceof ApiError && (query.error.status === 401 || query.error.status === 403);
  const error = query.error && !errIsAuth ? query.error.message : null;

  return {
    stats: query.data ?? [],
    loading: query.isPending && enabled,
    error,
  };
}
